import { InjectionToken } from '@angular/core';
import { ITileRequest } from '../services/tile-creator.service';

export const TILE_REQUEST = new InjectionToken<ITileRequest>('tileRequest');
